import(/* webpackMode: "eager", webpackExports: ["Avatar"] */ "/app/src/components/common/Avatar/Avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DynamicLeafletMap"] */ "/app/src/components/templates/employer/profile/details/DynamicLeafletMap.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/employer/profile/details/EmployerBenefits.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/employer/profile/details/EmployerDescription.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmployerGallery"] */ "/app/src/components/templates/employer/profile/details/EmployerGallery.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmployerShare"] */ "/app/src/components/templates/employer/profile/details/EmployerShare.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/employer/profile/details/ProfileActions.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/templates/employer/profile/details/SimilarWorkplacesListInfinite.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EmployerJobsSection"] */ "/app/src/components/templates/employer/profile/jobs/ActivationsSection.tsx");
